export default __webpack_public_path__ + "static/media/redwan.ba6558f2.png";